import { render, staticRenderFns } from "./EModalVisualizarTurma.vue?vue&type=template&id=86fa4512&scoped=true"
import script from "./EModalVisualizarTurma.vue?vue&type=script&lang=js"
export * from "./EModalVisualizarTurma.vue?vue&type=script&lang=js"
import style0 from "./EModalVisualizarTurma.vue?vue&type=style&index=0&id=86fa4512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fa4512",
  null
  
)

export default component.exports